var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import "./SwitchSessionDialog.component.css";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { useState } from "react";
import { CreateSessionDialog } from "../create-session-dialog/CreateSessionDialog.component";
import { SessionSelect } from "../../components/session-select/SessionSelect.component";
import { LabelledElement } from "../../components/labelled-element/LabelledElement.component";
import { useSessionSelectHandlers } from "../../hooks/session-select-handler.hook";
import { useTranslation } from "react-i18next";
export function SwitchSessionDialog({ onClose }) {
    var _a;
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const { targetSession, targetSessionName, setTargetSessionName, targetEqualsCurrent, handleSessionSelectionChanged, handleSessionCreated, switchSession } = useSessionSelectHandlers(onClose, () => {
        setShowCreateDialog(false);
    });
    const [selectedSessionName, setSelectedSessionName] = useState(targetSessionName);
    const { t } = useTranslation();
    const handleSessionCreatedLocal = (sessionName) => __awaiter(this, void 0, void 0, function* () {
        yield handleSessionCreated(sessionName);
        setSelectedSessionName(sessionName);
        setTargetSessionName(sessionName);
    });
    const handleSessionSelectionChangedLocal = (session) => __awaiter(this, void 0, void 0, function* () {
        yield handleSessionSelectionChanged(session);
        setSelectedSessionName(session === null || session === void 0 ? void 0 : session.name);
        setTargetSessionName(session === null || session === void 0 ? void 0 : session.name);
    });
    return (React.createElement(React.Fragment, null,
        !showCreateDialog && (React.createElement(GenericDialog, { title: t("sessionview:sessiondialog-title", "Switch Session"), confirmText: t("sessionview:sessiondialog-button-enter", "Enter Session"), confirmAllowed: !targetEqualsCurrent, confirmTooltipDisabled: targetSession
                ? t("sessionview:sessiondialog-confirm-tooltip-disabled-current-selected", "You are already in this session")
                : t("sessionview:sessiondialog-confirm-tooltip-disabled-no-selection", "Please select a session"), onCancel: onClose, onConfirm: switchSession, width: "medium" },
            React.createElement("div", { className: "switch-session-dialog-content" },
                React.createElement(SessionSelect, { sessionName: selectedSessionName, onSelectionChanged: handleSessionSelectionChangedLocal, onCreateClicked: () => {
                        setShowCreateDialog(true);
                    } }),
                React.createElement("div", { className: "switch-session-dialog-separator" }),
                React.createElement("section", { className: "switch-session-dialog-participants" },
                    React.createElement(LabelledElement, { label: t("sessionview:sessiondialog-activecount-label", "The selected session is active with:") },
                        React.createElement("span", null, t("sessionview:sessiondialog-activecount-content", "{{numParticipants}} participant(s)", {
                            numParticipants: (_a = targetSession === null || targetSession === void 0 ? void 0 : targetSession.participantCount) !== null && _a !== void 0 ? _a : 0
                        }))))))),
        showCreateDialog && (React.createElement(CreateSessionDialog, { onCancel: () => {
                setShowCreateDialog(false);
            }, onCreated: handleSessionCreatedLocal, size: "medium" }))));
}
